import { Placeholder, Table } from "react-bootstrap";

interface Props {
  rows?: number;
}

export const UnidadListSkeleton = ({ rows = 5 }: Props) => {
  return (
    <div
      className="table-responsive"
      style={{
        maxHeight: "300px",
        minHeight: "200px", // Dimensión fija para evitar movimiento
      }}
    >
      <Table striped>
        <thead style={{ backgroundColor: "#04144c", color: "white" }}>
          <tr>
            <th scope="col">Revisiones</th>
            <th scope="col">Ticket</th>
            <th scope="col">VIN</th>
            <th scope="col">Placa</th>
            <th scope="col">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, index) => (
            <tr key={`skeleton-${index}`}>
              <td>
                <Placeholder as="div" animation="glow">
                  <Placeholder xs={3} />
                </Placeholder>
              </td>
              <td>
                <Placeholder as="div" animation="glow">
                  <Placeholder xs={6} />
                </Placeholder>
              </td>
              <td>
                <Placeholder as="div" animation="glow">
                  <Placeholder xs={8} />
                </Placeholder>
              </td>
              <td>
                <Placeholder as="div" animation="glow">
                  <Placeholder xs={5} />
                </Placeholder>
              </td>
              <td>
                <Placeholder as="div" animation="glow">
                  <Placeholder xs={4} />
                </Placeholder>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};
